export default "__VITE_ASSET__88e38598__"